import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppointmentPartial } from '../../../../../services/incadea/incadea-interfaces/AppointmentPartial.interface';
import { Observable, forkJoin, observable, scheduled, tap, throwError } from 'rxjs';
import { APIDocumentTypeService } from 'src/services/api-services/api-document-type.service';
import { typeOfService } from 'src/services/api-services/api-interfaces/typeOfService.interface';
import DocumentType from '../../../../../services/api-services/api-interfaces/documentType.interface';
import { HelperService } from '../../../../../services/helperService';
import { VehicleRelationship } from 'src/services/api-services/api-interfaces/vehicleRelationship.interface';
import { APIVehicleRelationship } from 'src/services/api-services/api-vehicle-relationship.service';
import { AppointmentExtended } from 'src/services/incadea/incadea-interfaces/AppointmentExtended.interface';
import { catchError, filter } from 'rxjs/operators';
import { GetAppointmentCreate } from 'src/services/incadea/incadea-services/getAppointmentCreate.service';
import { AppointmentCreate } from 'src/services/incadea/incadea-interfaces/requests/RequestAppointmentCreate.interface';
import { vehicle, dataPrivacyConsent } from '../../../../../services/incadea/incadea-interfaces/requests/RequestAppointmentCreate.interface';
import { Appointment } from '../../../../../models/appointment';
import moment from 'moment';
import { ResponseAppointment } from 'src/services/incadea/incadea-interfaces/responses/ResponseAppointment.interface';
import { ABappointment } from 'src/services/api-services/api-interfaces/IBAppointment.interface';
import { ResponseServices } from 'src/services/incadea/incadea-interfaces/responses/ResponseServices.interface';
import { IncadeaBookingService } from 'src/services/api-services/IncadeaBooking.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import 'moment/locale/es';
import { Representative } from '../../../../../services/api-services/api-interfaces/IBAppointmentGET.interface';

const noSpecialCharsValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};
const emailValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? {'invalidEmail': {value: control.value}} : null;
};

const numbersOnlyValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const invalid = /[^0-9]/.test(control.value);
  return invalid ? {'numbersOnly': {value: control.value}} : null;
};

function yesSelectedValidator(control: AbstractControl) {
  const value = control.value;
  if (value === 'si') {
    return null; // The form is valid
  } else {
    return { 'yesSelected': true }; // The form is invalid
  }
}

@Component({
    selector: 'app-i-reschedule',
    templateUrl: './appointment.component.html',
    styleUrls: ['./appointment.component.sass'],
    standalone: false
})
export class AppointmentComponent implements OnInit {

  data$?: Observable<any>;
  isSaving = true;
  isThereABlockForRole = false;
  isAdvisorSelected;
  allAvailableAdvisors: any[] = [];
  documentType$: Observable<DocumentType[]> = new Observable<DocumentType[]>();
  relationshipCustomerVehicle$: Observable<VehicleRelationship[] > = new Observable<VehicleRelationship[]>();
  channel= [
    "Post",
    "Email",
    "Phone",
    "MobilePhone",
    "Fax",
    "SMS",
    "WhatsApp",
    "FbMessenger",
    "WeChat",
  ];
  dataLoading$:Observable<any>= new Observable()
  isEditingRepresentative= true;
  dataCreationAppointmentBooking!:  ABappointment;
  public isNewUser = true;
  public receivedNameCountry: any = history.state.nameCountry as {}
  servicesSelect!: ResponseServices
  public bannerSuccesURL=''
  public isLoading: boolean = false;
  isEditingOwner:boolean=true
  customerDocumentTypeName:string=""
  relationshipCustomerVehicleName:string=""
  editButton= false;
  isEditable= true;
  isLoadingSave=true;
  slotDuration= 15
 charCount: number = 0;


  constructor(
  private fb: FormBuilder,
  public typeOfDocumentService: APIDocumentTypeService,
  public helperService: HelperService,
  public VehicleRelationshipService: APIVehicleRelationship,
  public getAppointmentCreate:GetAppointmentCreate,
  public getCreateIncadeaBooking: IncadeaBookingService,
  private router: Router,private translate: TranslateService,
  public dialogRef: MatDialogRef<any>,

  @Inject(MAT_DIALOG_DATA) public appointment: AppointmentExtended,
  ) { }


  ngOnInit(): void {
    const diferentInMinutes =  (Number( new Date(this.appointment.end)) - Number(new Date( this.appointment.start))) / 60000;
    this.slotDuration = diferentInMinutes

  if (this.appointment?.customerVehicleData)
      {

    this.isEditingOwner=false
    this.isNewUser = false

      }
    this.relationshipCustomerVehicle$ =this.VehicleRelationshipService.getAllVehicleRelationships().pipe(tap((response)=>
      this.relationshipCustomerVehicleName=response.find(x=>x.relationshipVehicleId===this.relationshipCustomerVehicleControl.value)?.relationshipName!
    ))
    this.documentType$ = this.typeOfDocumentService.GetByCountryId(this.helperService.user.countryId)
      .pipe(
        tap((response)=>
          this.customerDocumentTypeName=response.find(x=>x.typeId===this.typeOfDocumentControl.value)?.typeName!
        ),
        catchError((error: any) => {
          // Manejo de error 401
          if (error.status === 401) {
            this.helperService.logoutToken();
          }

          // Handle validation error here
          console.error('Validation Error:', error);
          // Rethrow the error to propagate it downstream
          return throwError(error);
        })
      )

    this.dataLoading$ = forkJoin([
      this.documentType$, this.relationshipCustomerVehicle$,
    ])

    this.dataCustomerLoading()
  }

  editOwner() {
    this.editButton = false;
    this.isEditingOwner = true;
  }

  updateOwner() {
    this.appointmentForm.get("owner")?.reset();
    // this.appointmentForm.get("owner")?.get("plate")?.setValue(this.appointment.vehicleData.plate)
    this.isEditingOwner = true;
    this.editButton = false;
  }
  enableFields() {
    this.editButton = !this.editButton;
  }

  dataCustomerLoading(){
    console.log(this.appointment.customerVehicleData)
    this.appointmentForm.reset({
      owner: {
        firstNames: this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.firstName : "",
        lastNames: this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.lastName : "",
        typeOfDocument:  this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.typeId: 0,
        numberOfDocument: this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.identification : "",
        relationshipCustomerVehicle: this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.relationshipVehicleId : "",
        phone: this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.phone : "",
        email: this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.email : "",
        plate: this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.plate : "",
        vin: this.appointment && this.appointment.customerVehicleData? this.appointment.customerVehicleData.vin : "",
      }, representative: {
        willOwnerShowUp: true,
        namesRepresentative: "",
        lastnamesRepresentative: "",
        typeOfDocumentRepresentative: "",
        numberOfDocumentRepresentative: "",
        // relacionClienteVehiculoRepresentante: "",
        phoneRepresentative: "",
        emailRepresentative: "",
      },
    })
  }
  appointmentForm = this.fb.group({
    owner: this.fb.group({
    firstNames: ["", [ Validators.required, noSpecialCharsValidator ]],
    lastNames: ["", [ Validators.required, noSpecialCharsValidator ]],
    typeOfDocument: [0, Validators.required],
    numberOfDocument: ["", [ Validators.required ]],
    relationshipCustomerVehicle: ["", Validators.required],
    phone: ["", [ Validators.required, numbersOnlyValidator ]],
    email: [ "", [ Validators.required,  emailValidator,noSpecialCharsValidator ]],
    plate: ["", [ Validators.required, Validators.minLength(5)]],
    vin: ["", [noSpecialCharsValidator]],
    // Agrega aquí más campos según tus necesidades
  }),
  representative: this.fb.group({
    willOwnerShowUp: true,
    namesRepresentative: ["", [Validators.required]],
    lastnamesRepresentative: ["", [Validators.required]],
    typeOfDocumentRepresentative: ["", [Validators.required]],
    numberOfDocumentRepresentative: ["", [Validators.required]],
    // relacionClienteVehiculoRepresentante: "",
    phoneRepresentative: ["", [ Validators.required, numbersOnlyValidator ]],
    emailRepresentative:  [ "", [ Validators.required, Validators.email ]],
  }),
  scheduled: this.fb.group({
    Brand: ["",],
    city: ["",],
    tipeOfService: ["",],
    workshop: ["",],
    advisor: ["",],
    mileage: ["", [Validators.required]],
    channel: ["", [Validators.required]],
    observation: [""],
  }),
  termsAndPolitics: this.fb.group({
    terms: ["", [Validators.required, yesSelectedValidator]],
    policies: ["", [Validators.required, yesSelectedValidator]]
  })
  });

  onSave(){
    this.isLoadingSave=false;
    this.isSaving = false;


    let limitDate = new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 6) ).slice(-2) + '-' + "15" + 'T23:59:00'
    if(new Date().getMonth() + 6 > 12){
    limitDate = new Date().getFullYear()+1 + '-' +('0' + (new Date().getMonth() + 6 - 12) ).slice(-2) + '-' +  "15" + 'T23:59:00'
    }
    const token:string=this.appointment.token
    const companyId:string=this.appointment.selectedCompany.Id
    const Vehicle={
      Vin:String ( this.appointmentForm.get('owner')?.get("vin")?.value),
      LicenseNo:String (this.appointmentForm.get('owner')?.get("plate")?.value),
      Make:String ( this.appointment.selectedMake.Code),
      Department:String (this.appointment.selectedDepartment.Code)
      }
    const Customer={
      Name:String (this.appointmentForm.get('owner')?.get("firstNames")?.value)+' '+String(this.appointmentForm.get('owner')?.get("lastNames")?.value),
      Phone: {
        PhoneNo: String(this.appointmentForm.get('owner')?.get("phone")?.value),
        Type:"Business"
      },
      Email: {
        Email:String(this.appointmentForm.get('owner')?.get("email")?.value),
        Type:"Business"
      }}


    const DataPrivacyConsent=[{
      Beneficiary: this.appointment.selectedDepartment.Description,
      Purpose:{
        Type:"Business",
        CommunicationChannels:[String( this.appointmentForm.get('scheduled')?.get("channel")?.value)]
      },
      Description: String(this.appointmentForm.get('scheduled')?.get("observation")?.value),
      ExpirationDate:limitDate,
      CreatedOn:new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2) + 'T' + ('0' + new Date().getHours()).slice(-2) + ':' +('0' + new Date().getMinutes()).slice(-2)+ ':' +('0' + new Date().getSeconds()).slice(-2)
      }]
    const appointmentData:AppointmentCreate={
      LocationId: this.appointment.selectedLocation.Id,
      Vehicle:Vehicle,
      Customer:Customer,
      TimeslotFrom:this.appointment.start.toISOString().substring(0,11)+this.appointment.start.toTimeString().substring(0,8),
      PreferredPaymentMethod: "EF",
      Comment:String( this.appointmentForm.get('scheduled')?.get("observation")?.value),
      ResourceIds: [this.appointment.selectedResource.Id],
      services:[{Id:this.appointment.selectedService.Id}],
      DataPrivacyConsent
    }
    this.getAppointmentCreate.postAppointmnet(token, companyId, appointmentData,this.helperService.user.incadeaBackendCode! ).pipe(tap((response)=>{

      if (response.AppointmentId) {
      this.createApointmentBooking(response);
      // this.dialogRef.close();
      // this.isLoadingSave=true
      }
    })).subscribe({
      error: (response)=>{

        this.helperService.showAlert =true
        this.helperService.typeAlert ="warning"
        this.helperService.messageAlert =response.error.Detail
        setTimeout(() => {
          this.helperService.showAlert =false
          }, 7000)
        this.dialogRef.close(true);
      }
    })
  }

  createApointmentBooking(response:ResponseAppointment){

    let limitDate = new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 6) ).slice(-2) + '-' + "15" + 'T23:59:00'
    if(new Date().getMonth() + 6 > 12){
    limitDate = new Date().getFullYear()+1 + '-' +('0' + (new Date().getMonth() + 6 - 12) ).slice(-2) + '-' +  "15" + 'T23:59:00'
    }

    this.dataCreationAppointmentBooking={
      AppointmentId:          response.AppointmentId,
      DocumentNo:             response.DocumentNo,
      CompanyId:              this.appointment.selectedCompany.Id,
      CompanyName:            this.appointment.selectedCompany.Description,
      LocationName:           this.appointment.selectedLocation.Description,
      LocationId: this.appointment.selectedLocation.Id,
      CountryId:String(this.helperService.user.countryId),
      UserId:String(this.helperService.user.userid) ,
      Vehicle:{
        VIN:  String ( this.appointmentForm.get('owner')?.get("vin")?.value),
        LicenseNo: String(this.appointmentForm.get('owner')?.get("plate")?.value),
        Make:String ( this.appointment.selectedMake.Code),
        Department:String (this.appointment.selectedDepartment.Code),
        MakeName : this.appointment.selectedMake.Description,
        DepartmentName:this.appointment.selectedDepartment.Description,
        RelationshipVehicle:"1",
        Mileage:String(this.appointmentForm.get('scheduled')?.get("mileage")?.value)
      },
      Customer:{
        CustomerId:String( this.appointmentForm.get('owner')?.get("numberOfDocument")?.value),
        DocumentTypeId: String( this.appointmentForm.get('owner')?.get("typeOfDocument")?.value),
        Name:String (this.appointmentForm.get('owner')?.get("firstNames")?.value)+' '+String(this.appointmentForm.get('owner')?.get("lastNames")?.value),
        Phone:{
          PhoneNo:String(this.appointmentForm.get('owner')?.get("phone")?.value),
          Type:"Business"
        },
        Email:{
          Email:String(this.appointmentForm.get('owner')?.get("email")?.value),
          Type:"Business"
        },
        IsCustomerPresent:this.isEditingRepresentative? "1" : "0"
      },

      Representative: {
        DocumentNumber:String(this.appointmentForm.get('representative')?.get("numberOfDocumentRepresentative")?.value),
        DocumentType:String(this.appointmentForm.get('representative')?.get("typeOfDocumentRepresentative")?.value),
        RepresentativeFullName:String (this.appointmentForm.get('representative')?.get("namesRepresentative")?.value)+' '+String(this.appointmentForm.get('representative')?.get("lastnamesRepresentative")?.value
        ),
        Email: String(this.appointmentForm.get('representative')?.get("emailRepresentative")?.value)
    },

      TimeslotFrom:this.appointment.start.toISOString().substring(0,11)+this.appointment.start.toTimeString().substring(0,8),
      Duration:String(this.slotDuration),
      PreferredPaymentMethod :"EF",
      Comment: String ( this.appointmentForm.get('scheduled')?.get("observation")?.value) ,
      SchedulerStatusId: String(1),
      CountryName:String(this.appointment.selectedLocation.Address.Country),
      ResourceIds:[{ ResourceId:this.appointment.selectedResource.Id,ResourceName:this.appointment.selectedResource.Description}],
      Services:[{ServiceName:this.appointment.selectedService.Name,Id:this.appointment.selectedService.Id}],
      DataPrivacyConsent:[{
        Beneficiary:this.appointment.selectedDepartment.Description,
        Purpose:{
          Type:"Business",
          CommunicationChannels:[String( this.appointmentForm.get('scheduled')?.get("channel")?.value)]
        },
        Description:String ( this.appointmentForm.get('scheduled')?.get("observation")?.value) ,
        ExpirationDate:limitDate,
        CreatedOn: new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2) + 'T' + ('0' + new Date().getHours()).slice(-2) + ':' +('0' + new Date().getMinutes()).slice(-2)+ ':' +('0' + new Date().getSeconds()).slice(-2)

       }],
     
        UtmSource:"" ,
        UtmCampaign:"" ,
        UtmMedium:"" ,
        UtmContent:"" ,
        UtmTerm: "",
        RecaptchaToken:"ok"
      
    }

    let serviceNameSelected:string= this.appointment.selectedService.Name;
    let dateSelected:string =this.appointment.start.toLocaleDateString(this.helperService.user.language, {
      weekday: 'short', // muestra el día de la semana
      year: 'numeric', // muestra el año
      month: 'short',   // muestra el mes completo
      day: 'numeric'   // muestra el día
  })
    let timeTransform = moment(this.appointment.start).format('h:mm a')

    this.getCreateIncadeaBooking.createIBAppointment(this.dataCreationAppointmentBooking).pipe(tap((response)=>{
      if (response.message === "Appointment Created Successfully") {
        const createSuccessMessage = this.translate.instant('ScheduleSavedSuccess',{
          serviceNameSelected: this.translate.instant(serviceNameSelected),
          dateSelected: this.translate.instant(dateSelected),
          time: this.translate.instant(timeTransform)
        });
        this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =createSuccessMessage
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)

        this.dialogRef.close(true);
      this.isLoadingSave=true
      }
    })).subscribe({
      error: (err)=>{
        // Manejo de error 401
        if (err.status === 401) {
          this.helperService.logoutToken();
        }
      }
    })
  }

  formsValidations(): boolean {
    if (this.isEditingRepresentative) {
      const isFormValidation2Invalid =this.appointmentForm.get("owner")!.invalid  || this.appointmentForm.get("scheduled")!.invalid || this.appointmentForm.get("termsAndPolitics")!.invalid;
      return isFormValidation2Invalid;
    } else {
      if (this.appointmentForm.get("owner")!.invalid  || this.appointmentForm.get("scheduled")!.invalid || this.appointmentForm.get("termsAndPolitics")!.invalid) {
        return true;
      } else {
        return this.appointmentForm.get("representative")!.invalid;
      }
    }

  }


  get  firstNamesControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("firstNames") as FormControl;
  }
  get  lastNamesControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("lastNames") as FormControl;
  }
  get  typeOfDocumentControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("typeOfDocument") as FormControl;
  }
  get  numberOfDocumentControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("numberOfDocument") as FormControl;
  }
  get  relationshipCustomerVehicleControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("relationshipCustomerVehicle") as FormControl;
  }
  get  phoneControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("phone") as FormControl;
  }
  get  emailControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("email") as FormControl;
  }
  get  plateControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("plate") as FormControl;
  }
  get  vinControl(): FormControl {
    return this.appointmentForm.get('owner')?.get("vin") as FormControl;
  }

  get  advisorControl(): FormControl {
    return this.appointmentForm.get('scheduled')?.get("advisor") as FormControl;
  }
  get  termsControl(): FormControl {
    return this.appointmentForm.get('termsAndPolitics')?.get("terms") as FormControl;
  }
  get  policiesControl(): FormControl {
    return this.appointmentForm.get('termsAndPolitics')?.get("policies") as FormControl;
  }

  get  mileageControl(): FormControl {
    return this.appointmentForm.get('scheduled')?.get("mileage") as FormControl;
  }
  get  channelControl(): FormControl {
    return this.appointmentForm.get('scheduled')?.get("channel") as FormControl;
  }

  get  namesRepresentativeControl(): FormControl {
    return this.appointmentForm.get('representative')?.get("namesRepresentative")  as FormControl;
  }
  get  lastnamesRepresentativeControl(): FormControl {
    return this.appointmentForm.get('representative')?.get("lastnamesRepresentative")  as FormControl;
  }
  get  typeOfDocumentRepresentativeControl(): FormControl {
    return this.appointmentForm.get('representative')?.get("typeOfDocumentRepresentative")  as FormControl;
  }
  get  numberOfDocumentRepresentativeControl(): FormControl {
    return this.appointmentForm.get('representative')?.get("numberOfDocumentRepresentative")  as FormControl;
  }
  get  phoneRepresentativeControl(): FormControl {
    return this.appointmentForm.get('representative')?.get("phoneRepresentative")  as FormControl;
  }
  get  emailRepresentativeControl(): FormControl {
    return this.appointmentForm.get('representative')?.get("emailRepresentative")  as FormControl;
  }
}
